import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { UrlArgumentsStore } from '../stores/UrlArgumentsStore';
import { GlobalHelper } from '../utils/GlobalHelper';

interface ExportButtonState {
    hookUrl: string;
    sessionId?: string;
}

export class ExportButton extends React.Component<{}, ExportButtonState> {
    public componentWillMount(): void {
        this.setState({
            hookUrl: UrlArgumentsStore.getState().hookUrl
        });
    }

    public componentDidUpdate(): void {
        if (this.state.sessionId != null) {
            (ReactDOM.findDOMNode(this) as HTMLFormElement).submit();
        }
    }

    public render(): JSX.Element | null {
        if (this.state.hookUrl == null) {
            return null;
        }

        if (this.state.sessionId == null) {
            return (
                <div className="sidebar-tab-button export" onClick={this.onClick}><span/></div>
            );
        }

        return (
            <form action={this.state.hookUrl} method="post">
                <input type="hidden" name="sessionId" value={this.state.sessionId} />
            </form>
        );
    }

    protected onClick = (): void => {
        GlobalHelper.articleManager.synchronizeSession(true).then(() => {
            this.setState({
                hookUrl: this.state.hookUrl,
                sessionId: GlobalHelper.eaiwsSession.session.sessionId
            });
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ExportButton.tsx